const bridges = new Map();

const DEFAULT_DELAY = 100;
const MAX_RETRIES = 300; // 300 * 100 = 30 seconds

function createBridge({
  src,
  async = true,
  ready,
  delay = DEFAULT_DELAY,
  retries = MAX_RETRIES
}) {
  return new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = async;
    s.src = src;
    document.getElementsByTagName('body')[0].appendChild(s);
    if (typeof ready === 'function') {
      if (async === false && ready()) {
        return resolve();
      }

      let cnt = 0;

      const interval = setInterval(() => {
        const result = ready();

        if (result || cnt > retries) {
          clearInterval(interval);
          return result ? resolve(result) : reject();
        }
        cnt++;
      }, delay);

      return;
    }

    return resolve();
  });
}

export default function(opts = {}) {
  if (!opts.src) {
    return Promise.reject(new Error('Bridge requires a valid src'));
  }

  const key = JSON.stringify(opts);

  if (!bridges.has(key)) {
    bridges.set(key, createBridge(opts));
  }
  return bridges.get(key);
}
